import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import './AdminReviews.css';

const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authError, setAuthError] = useState('');

  // Simple password check (you'll set this password)
  const ADMIN_PASSWORD = 'gita2024admin'; // Change this to your desired password

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setAuthError('');
      loadReviews();
    } else {
      setAuthError('Incorrect password');
    }
  };

  const loadReviews = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('reviews')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setReviews(data || []);
    } catch (error) {
      console.error('Error loading reviews:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this review?')) {
      return;
    }

    try {
      const { error } = await supabase
        .from('reviews')
        .delete()
        .eq('id', id);

      if (error) throw error;
      
      // Remove from local state
      setReviews(reviews.filter(review => review.id !== id));
    } catch (error) {
      console.error('Error deleting review:', error);
      alert('Failed to delete review');
    }
  };

  const handleApprove = async (id, currentStatus) => {
    try {
      const { error } = await supabase
        .from('reviews')
        .update({ approved: !currentStatus })
        .eq('id', id);

      if (error) throw error;
      
      // Update local state
      setReviews(reviews.map(review => 
        review.id === id ? { ...review, approved: !currentStatus } : review
      ));
    } catch (error) {
      console.error('Error updating review:', error);
      alert('Failed to update review');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-container">
          <h2>Admin Login</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              className="password-input"
            />
            {authError && <p className="error-message">{authError}</p>}
            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-reviews">
      <div className="admin-header">
        <h1>Review Management</h1>
        <button onClick={() => setIsAuthenticated(false)} className="logout-btn">
          Logout
        </button>
      </div>

      {loading ? (
        <p className="loading">Loading reviews...</p>
      ) : reviews.length === 0 ? (
        <p className="no-reviews">No reviews yet.</p>
      ) : (
        <div className="reviews-list">
          {reviews.map((review) => (
            <div key={review.id} className={`review-card ${review.approved ? 'approved' : 'pending'}`}>
              <div className="review-header">
                <div>
                  <h3>{review.name}</h3>
                  <span className={`status-badge ${review.approved ? 'approved' : 'pending'}`}>
                    {review.approved ? 'Approved' : 'Pending Approval'}
                  </span>
                </div>
                <div className="review-date">
                  {new Date(review.created_at).toLocaleDateString()}
                </div>
              </div>
              
              <p className="review-text">"{review.text}"</p>
              
              <div className="review-actions">
                <button 
                  onClick={() => handleApprove(review.id, review.approved)}
                  className={`approve-btn ${review.approved ? 'unapprove' : ''}`}
                >
                  {review.approved ? 'Unapprove' : 'Approve'}
                </button>
                <button 
                  onClick={() => handleDelete(review.id)}
                  className="delete-btn"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminReviews;

